import baseKey from './_baseKey';

const buildingDomainKey = (buildingSubDomains?: string[]) =>
  baseKey.domainKey('building', buildingSubDomains);

/**
 * 빌딩 관련 쿼리키 제너레이터
 */
const buildingKey = {
  /**
   * @returns 빌딩 도메인 기본 쿼리키 (getter)
   * @example ['building']
   */
  domain() {
    return buildingDomainKey();
  },
  /**
   * @param payload 주소에 대한 정보를 포함하는 빌딩 리스트 파라미터 (src/types/venue.d.ts 참고)
   * @returns 주소에 대한 빌딩 리스트를 요청하는 쿼리키
   * @example ['building', 'meta', 'list', 'all', ...param]
   */
  metaList(payload: Building.Meta.Payload | null) {
    return [...baseKey.listKey(buildingDomainKey(['meta']), 'all'), payload];
  },
  /**
   * @param id 빌딩 id
   * @returns 해당 빌딩 내의 층 정보 리스트를 요청하는 쿼리키
   * @example ['building', 'floor', 'list', 'all', 1]
   */
  floorList(id: number) {
    return [...baseKey.listKey(buildingDomainKey(['floor']), 'all'), id];
  },
};

export default Object.freeze(buildingKey);
